"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAccount = exports.setTxInteraction = exports.removePopup = exports.addPopup = exports.updateBlockNumber = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.updateBlockNumber = (0, toolkit_1.createAction)("application/updateBlockNumber");
exports.addPopup = (0, toolkit_1.createAction)("application/addPopup");
exports.removePopup = (0, toolkit_1.createAction)("application/removePopup");
exports.setTxInteraction = (0, toolkit_1.createAction)("application/setTxInteraction");
exports.setAccount = (0, toolkit_1.createAction)("application/setAccount");
